import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c45a9a46"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c45a9a46')) {
      api.createRecord('c45a9a46', component.options)
    } else {
      api.reload('c45a9a46', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=c45a9a46", function () {
      api.rerender('c45a9a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/role/Index.vue"
export default component.exports